<template>
  <form class="promo-code-form" @submit.prevent="submit()">
    <div class="input-container">
      <label v-if="showPromoCodeLabel" for="promo-code">Promo Code</label>
      <div class="input-wrapper with-actions">
        <input
          id="promo-code"
          :value="inputPromoCode"
          type="text"
          placeholder="Enter Promo Code"
          :class="{
            spaced: inputPromoCode !== '',
          }"
          @input="inputPromoCode = $event.target.value.toUpperCase()"
        />
        <div class="actions">
          <div
            class="action"
            :class="{
              'action--disabled': paymentLoading || promoCodeSubmitting || inputPromoCode === '',
            }"
            @click="submit()"
          >
            Apply
          </div>
        </div>
      </div>
    </div>

    <div v-if="activePromoCodes.length > 0">
      <div
        v-for="promoCode in activePromoCodes"
        :key="'checkout-relevant-promo-code_' + promoCode.code"
        class="notice"
      >
        {{ promoCode.label }}
      </div>
    </div>
    <div v-if="promoCodeError" class="error">
      {{ promoCodeError }}
    </div>
  </form>
</template>

<script>
import { mapActions, mapGetters } from "vuex"
export default {
  props: {
    activePromoCodes: {
      type: Array,
      default: () => {
        return []
      },
    },
    showPromoCodeLabel: {
      type: Boolean,
      default: true,
    },
  },
  data: function () {
    return {
      inputPromoCode: "",
      promoCodeSubmitting: false,
      promoCodeError: null,
    }
  },
  computed: {
    ...mapGetters("Payment", [
      "paymentLoading",
    ]),
  },
  methods: {
    ...mapActions("Payment", [
      "fetchAppliedPromoCodes",
      "redeemPromoCodes",
    ]),
    async submit () {
      if (this.promoCodeSubmitting) {
        return
      }

      this.promoCodeError = null
      this.promoCodeSubmitting = true
      try {
        await this.redeemPromoCodes(this.inputPromoCode)
        await this.fetchAppliedPromoCodes()
      } catch (e) {
        this.promoCodeError = e?.response?.data?.error || "Failed to apply Promo Code."
      }

      this.promoCodeSubmitting = false
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/_mixins.scss";
@import "@/assets/style/_variables.scss";

.promo-code-form {
  padding: 0 4rem;
  margin-top: 2rem;
  @include phone-small {
    padding: 0 2rem;
  }

  .notice,
  .error {
    font-family: Proxima Nova;
    font-style: normal;
    font-weight: 400;
    font-size: 1.3rem;
    padding: 1rem 1.6rem;
    border-radius: 4px;
    text-align: center;
    margin: 1rem 0;
  }

  .notice {
    background: rgba(200, 250, 238, 0.8);
    color: #00c8b4;
  }

  .error {
    background: rgba(250, 200, 206, 0.8);
    color: #db1d3f;
  }

  .input-container {
    text-align: left;

    .input-wrapper {
      &.with-actions {
        position: relative;

        input {
          padding-right: 10.1rem;

          &.spaced {
            letter-spacing: 0.1em;
          }
        }

        .actions {
          font-weight: 600;
          display: flex;
          justify-content: center;
          align-items: center;
          position: absolute;
          top: 0;
          right: 0;
          width: 10rem;
          height: 100%;

          .action {
            color: $pg-blue;
            cursor: pointer;
            font-size: 1.3rem;
            text-transform: uppercase;
            user-select: none;

            &--disabled {
              cursor: auto;
              opacity: 0.2;
            }

            &--readonly {
              color: #00c8b4;
              cursor: auto;
              opacity: 1;
            }
          }
        }
      }
    }

    label {
      display: block;
      font-style: normal;
      font-weight: 600;
      font-size: 1.3rem;
      line-height: 1.6rem;
      margin: 0.9rem 0 1.3rem;

      @include phone-small {
        margin: 0.5rem 0 1rem;
      }
    }

    input,
    select {
      width: 100%;
      outline: none;
      border: 1px solid #dcdcdc;
      border-radius: 6px;
      padding: 1.1rem 1.1rem;
      font-family: Proxima Nova;
      font-style: normal;
      font-weight: normal;
      font-size: 1.6rem;
    }

    select {
      padding: 1rem 1.1rem;
      cursor: pointer;
    }

    .card-number-container {
      width: 100%;
      border-radius: 6px;
      border: 1px solid #dcdcdc;
      display: grid;
      grid-template-columns: 4fr 2fr 1.1fr;

      @include phone-down {
        grid-template-columns: 4fr 2fr 1.3fr;
      }

      @include phone-small {
        grid-template-columns: 4fr 2fr 1.5fr;
      }

      input {
        border: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/payment_v2/PromoCodeForm.vue